import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from'crypto-js';

const StudentInfoPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    studentId: '',
    studentName: '',
    personId: ''
  });
  const [errors, setErrors] = useState({
    idError: false,
    nameError: false,
    personidError: false
  });
  const [result, setResult] = useState({
    show: false,
    success: false,
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateStudentId = (studentId) => {
    const regex = /^.*$/s;
    return regex.test(studentId);
  };

  const validateStudentName = (name) => {
    // 允许中文和·，·不能出现在开头或结尾，总长度2-25
    const regex = /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/;
    return regex.test(name) && name.length >= 2 && name.length <= 25;
};

  const validatePersonId = (personid) => {
    const regex = /^\d{17}[\dXx]$/;
    return regex.test(personid);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    
    // Reset error for this field
    if (errors[`${id}Error`]) {
      setErrors({ ...errors, [`${id}Error`]: false });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    let isValid = true;
    const newErrors = { idError: false, nameError: false, personidError: false };
    
    if (!formData.studentId || !validateStudentId(formData.studentId)) {
      newErrors.idError = true;
      isValid = false;
    }
    
    if (!formData.studentName || !validateStudentName(formData.studentName)) {
      newErrors.nameError = true;
      isValid = false;
    }
    
    if (!formData.personId || !validatePersonId(formData.personId)) {
      newErrors.personidError = true;
      isValid = false;
    }
    
    setErrors(newErrors);
    
    if (!isValid) {
      setResult({
        show: true,
        success: false,
        message: '请修正表单中的错误后重新提交'
      });
      return;
    }
    
    // Show loading
    setResult({
      show: true,
      success: true,
      message: '正在验证信息...'
    });
    
    // 仅在验证通过后锁定按钮
    setIsSubmitting(true);
    
    try {
      // 关键修复：将十六进制密钥解析为二进制（与后端Buffer.from(..., 'hex')对应）
      const key = CryptoJS.enc.Hex.parse('bf963579b7776a26bd896146e86f142b012759ca804286bddf2e5cbb5691b297');
      // IV同样是十六进制，需用Hex解析（原代码用Utf8解析错误）
      const iv = CryptoJS.enc.Hex.parse('f0f59591751861b035cab33703e622a8');
    
      // 加密逻辑
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify({
          stuNum: formData.studentId,
          name: formData.studentName,
          idCard: formData.personId
        }),
        key, // 使用Hex解析后的密钥
        { 
          iv: iv, // 使用Hex解析后的IV
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7 // 与后端默认填充方式一致（PKCS#7）
        }
      ).toString();
  
      const response = await fetch('api/auth-logs/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          encrypted: encryptedData
        })
      });
      console.log('Response:', response);
      const data = await response.json();
      
      if (data.code === 0) {
        const postId = data.data?.id || '未知ID';
        sessionStorage.setItem('__secure_post_id', postId);
        
        setResult({
          show: true,
          success: true,
          message: `用户${formData.studentName}信息验证通过！`
        });
        
        setTimeout(() => {
          //  // 修改前
          //  navigate(data.url);
           
          // 修改后
          window.location.href = data.url;
        }, 1000);
      } else {
        setResult({
          show: true,
          success: false,
          message: data.msg || '验证失败，请重试'
        });
      }
    } catch (error) {
      setResult({
        show: true,
        success: false,
        message: `请求失败：${error.message}`
      });
      console.error('请求错误:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
        <img src="/logo.png" alt="泉州师范学院" className="header-logo" />
          <h1>统一身份认证系统——手机绑定</h1>
        </div>
        
        <div className="card-body">
          <form id="studentForm" onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="notice-banner">⭐️26级新生请于2026年8月20日之后办理手机号绑定</div>
              <label htmlFor="studentId">学号/工号</label>
              <div className="input-container">
                <input 
                  type="text" 
                  id="studentId" 
                  className="form-control" 
                  placeholder="请输入您的学号/工号"
                  value={formData.studentId}
                  onChange={handleInputChange}
                />
              </div>
              {errors.idError && (
                <div className="error" id="idError">学号格式不正确，应为8-12位数字</div>
              )}
              <div className="hint">示例：20250001</div>
            </div>
            
            <div className="form-group">
              <label htmlFor="studentName">姓名</label>
              <div className="input-container">
                <input 
                  type="text" 
                  id="studentName" 
                  className="form-control" 
                  placeholder="请输入您的姓名"
                  value={formData.studentName}
                  onChange={handleInputChange}
                />
              </div>
              {errors.nameError && (
                <div className="error" id="nameError">姓名格式不正确，应为2-25个中文字符</div>
              )}
              <div className="hint">示例：张三</div>
            </div>

            <div className="form-group">
              <label htmlFor="personId">身份证</label>
              <div className="input-container">
                <input 
                  type="text" 
                  id="personId" 
                  className="form-control" 
                  placeholder="请输入您的身份证"
                  value={formData.personId}
                  onChange={handleInputChange}
                />
              </div>
              {errors.personidError && (
                <div className="error" id="personidError">身份证格式不正确，应为18位</div>
              )}
              <div className="hint">示例：350500190001011010</div>
            </div>
            
            <button 
              type="submit" 
              className="btn"
              disabled={isSubmitting}
            >
              <i className="fa-soild-fa-check-circle"></i>
              {isSubmitting ? '提交中...' : '验证信息'}
            </button>
          </form>
          
          {result.show && (
            <div className={`result ${result.success ? 'success' : 'error-result'}`} id="result">
              <i className={result.success ? "fas fa-check-circle" : "fas fa-exclamation-circle"}></i>
              <h3>{result.success ? '验证成功！' : '验证失败'}</h3>
              <p>{result.message}</p>
            </div>
          )}
          
          <div className="validation-rules">
            <h4>验证规则说明</h4>
            <ul className="rules-list">
              <li>
                <i className="fas fa-check-circle"></i>
                <span>请如实填写学号/工号、姓名及大陆居民身份证号（外籍及港澳台人员暂不支持）</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>仅用于修改统一身份认证系统绑定的手机号，VPN手机号1个工作日同步更新</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>如需咨询请工作日办公时间致电22911950</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentInfoPage;